import React from "react";
import { connect } from "react-redux";

import { Dispatch, bindActionCreators } from "redux";

import { Overlay, ActionBar, Sticky } from "@plex/react-components";

import { Banner } from "ui/app";
import { ActionBarLink } from "ui/app/navigation";
import { useLocalizedValues } from "ui/hooks";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { TermDictionaryFilter } from "./filter";
import { TermDictionaryGrid } from "./grid";
import { termDictionaryActions } from "./TermDictionary.actions";
import { ITermDictionaryState, ITermDictionarySearchQuery } from "./TermDictionary.state";

interface ITermDictionaryProps {
  state: ITermDictionaryState;
  exportToXml: (searchQuery: ITermDictionarySearchQuery) => void;
}

const TermDictionary: React.FC<ITermDictionaryProps> = ({ state, exportToXml }) => {
  const localizedValues = useLocalizedValues(() => ({
    allTranslationsText: glossaryMessages.action("allTranslations"),
    exportText: glossaryMessages.action("exportTranslations")
  }));

  return (
    <>
      <Overlay show={state.isLoading} showSpinner />

      <Banner messages={state.notifications} />

      <TermDictionaryFilter />

      <Sticky>
        <ActionBar>
          <ActionBar.Button
            text={localizedValues.exportText}
            title={localizedValues.exportText}
            onClick={() => exportToXml(state.searchQuery)}
            disabled={!state.searchResult || (state.searchResult && state.searchResult.length === 0)}
          />
          <ActionBarLink
            openInDialog
            title={localizedValues.allTranslationsText}
            text={localizedValues.allTranslationsText}
            href={`/terms/${state.selectedRowId}/translations/${glossaryMessages.option("termTranslationStatusApproved").value}`}
            disabled={!state.selectedRowId}
          />
        </ActionBar>
      </Sticky>

      <TermDictionaryGrid />
    </>
  );
};

export default connect(
  (state: { termDictionary: ITermDictionaryState }) => {
    return {
      state: state.termDictionary
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        exportToXml: termDictionaryActions.exportTermTranslations
      },
      dispatch
    )
)(TermDictionary);
